import { apolloClient } from '@buy-viasat/utils';
import { GetAvailableProductsInputR0 } from '@buy-viasat/types/build/bv';
import { GET_AVAILABLE_PRODUCTS, GetAvailableProductsPayload } from './types';

// Kept in its own file so the browser Network tab shows this request's initiator as
// getAvailableProducts (matching getPartnerAccount) rather than the shared thunks.ts.
export const getAvailableProductsAsync = (input: GetAvailableProductsInputR0): Promise<GetAvailableProductsPayload> =>
  apolloClient.query({
    query: GET_AVAILABLE_PRODUCTS,
    variables: { input },
  });
